import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Inside from "@/components/Inside";
import Timeline from "@/components/Timeline";
import Testimonials from "@/components/Testimonials";
import Pricing from "@/components/Pricing";
import Faq from "@/components/Faq";
import Apply from "@/components/Apply";
import Footer from "@/components/Footer";
import StickyEnroll from "@/components/StickyEnroll";

export default function Landing() {
  return (
    <div className="relative">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Inside />
        <Timeline />
        <Testimonials />
        <Pricing />
        <Faq />
        <Apply />
      </main>
      <Footer />
      <StickyEnroll />
    </div>
  );
}
